function wrapStorage<T = any>(storage?: Storage) {
  const isStorageAvailable = (() => {
    const test = 'testIfStorageIsAvailable';

    try {
      storage!.setItem(test, test);
      storage!.removeItem(test);

      return true;
    } catch (_) {
      return false;
    }
  })();

  function get(key: string, defaultValue?: T) {
    if (!isStorageAvailable) {
      return defaultValue;
    }

    const value = storage!.getItem(key);

    if (value === null) {
      return defaultValue;
    }

    try {
      return JSON.parse(value) as T;
    } catch (_) {
      return defaultValue;
    }
  }

  function set(key: string, value: T) {
    if (!isStorageAvailable) {
      return false;
    }

    try {
      storage!.setItem(key, JSON.stringify(value));

      return true;
    } catch (_) {
      return false;
    }
  }

  function remove(key: string) {
    if (!isStorageAvailable) {
      return;
    }

    storage!.removeItem(key);
  }

  function clear() {
    if (!isStorageAvailable) {
      return;
    }

    storage!.clear();
  }

  return { clear, get, remove, set };
}

export const SESSION_STORAGE = typeof sessionStorage !== 'undefined' ? sessionStorage : undefined;
export const LOCAL_STORAGE = typeof localStorage !== 'undefined' ? localStorage : undefined;

export const wrapStorageWithKey = <T>(storage: Storage | undefined, key: string) => {
  const wrapped = wrapStorage<T>(storage);

  return {
    ...wrapped,
    clear: () => wrapped.remove(key),
    get: (defaultValue?: T) => wrapped.get(key, defaultValue),
    set: (value: T) => wrapped.set(key, value),
  };
};

export const LocalStorage = wrapStorage(LOCAL_STORAGE);
export const SessionStorage = wrapStorage(SESSION_STORAGE);
